import { Link } from "react-router-dom";
import { navCategories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-background-100">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-8 px-4 py-12 md:grid-cols-4 md:px-6">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-book-open-line text-xl" />
            </span>
            <span className="font-display text-lg font-extrabold text-foreground-950">
              韩漫免费看
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
            韩漫免费观看在线阅读漫画网站，汇聚丰富韩漫资源，涵盖爱情、奇幻、动作等多个题材，支持在线浏览最新更新章节，让您轻松体验精彩漫画内容。
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            <span className="rounded-full bg-primary-100 px-3 py-1 text-xs text-primary-800">
              免费阅读
            </span>
            <span className="rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-900">
              最新连载
            </span>
            <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
              多题材
            </span>
          </div>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-foreground-950">热门分类</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
            {navCategories.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/category/${c.slug}`}
                  className="transition-colors hover:text-primary-700"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-foreground-950">站点导航</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
            <li>
              <Link to="/" className="transition-colors hover:text-primary-700">
                首页
              </Link>
            </li>
            <li>
              <Link to="/search" className="transition-colors hover:text-primary-700">
                全站搜索
              </Link>
            </li>
            <li>
              <Link to="/about" className="transition-colors hover:text-primary-700">
                关于我们
              </Link>
            </li>
            <li>
              <Link to="/about" className="transition-colors hover:text-primary-700">
                联系反馈
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="mx-auto flex w-full max-w-7xl flex-col gap-2 px-4 py-5 text-xs text-foreground-500 md:flex-row md:items-center md:justify-between md:px-6">
          <p>© 2026 韩漫免费观看在线阅读漫画 · 本站内容均为演示数据，仅供学习参考</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>所有韩漫版权归原作者及出版方所有</span>
            <span className="hidden sm:inline">·</span>
            <span>本站不提供任何付费服务</span>
          </p>
        </div>
      </div>
    </footer>
  );
}